export interface GuessResult {
  valid: boolean;
  marks?: ('correct' | 'present' | 'absent')[];
  win?: boolean;
  answer?: string;
}

/**
 * Submit a guess to the backend.
 * @param guess 5-letter Cyrillic word (uppercase)
 * @param attempt 1-based attempt number (1..6). When attempt === 6 and not a
 *                win, backend reveals the answer so the client can show it on
 *                the end-of-game screen.
 */
export async function validateGuess(guess: string, attempt: number): Promise<GuessResult> {
  const res = await fetch('/api/guess', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ guess, lang: 'ru', attempt })
  });
  if (!res.ok) throw new Error(`api ${res.status}`);
  return res.json();
}
